// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"201":"887c0c84","206":"196c49be","477":"dfbe605d","536":"440334d2"}[chunkId] + ".css";
};